import DuplicateScheduleForm from './DuplicateScheduleForm';
import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { useParams } from 'react-router';


const DuplicateSchedulePage=()=>{
    const {scheduleId} = useParams()

        return(
            <Fragment>
            <Breadcrumbs parent="Master Data" title="Schedule Form" />
             <DuplicateScheduleForm scheduleId={scheduleId}/>
            </Fragment>
        )
}

export default DuplicateSchedulePage;